import { v4 as uuidv4 } from 'uuid';
import icon1 from '../../assets/img/icon/factory.png';

const videoFeaturedData = [
    {
        id: uuidv4(),
        icon: icon1,
        heading: 'Industrial Solutions',
        text: 'Lorem ipsum dolor sit ame ctetur adipisic ing elit',
    },

    {
        id: uuidv4(),
        icon: icon1,
        heading: 'Automotive Parts',
        text: 'Lorem ipsum dolor sit ame ctetur adipisic ing elit',
    },

    {
        id: uuidv4(),
        icon: icon1,
        heading: 'Power amd Energy',
        text: 'Lorem ipsum dolor sit ame ctetur adipisic ing elit',
    },

    {
        id: uuidv4(),
        icon: icon1,
        heading: 'Maintenance services',
        text: 'Lorem ipsum dolor sit ame ctetur adipisic ing elit',
    },
];

export default videoFeaturedData;
